// This file is mostly a hack to allow writing type-safe code that can be run by `Signage.js`.

import { Log } from '../AuxillaryService/Log';
import { NamedValueCacheInterface, Permission, PermissionInterface } from '../Platform';
import {
    ApiFeatures,
    FeatureEnrollment,
    FeatureEnrollmentPopulateError,
    features,
} from './FeatureEnrollment';
import { labOptions, LabOptions } from './LabOptions';

export async function initializeFeatureEnrollment(
    platform: NamedValueCacheInterface & PermissionInterface,
    apiResult: ApiFeatures
): Promise<void> {
    const initFeatureEnrollment = new FeatureEnrollment(platform);
    try {
        await initFeatureEnrollment.initialize(apiResult);
    } catch (err) {
        if (err instanceof FeatureEnrollmentPopulateError) {
            Log.Warning(String(err), null, __fileline);
        } else {
            Log.Error(
                `Failed to propagate enrolled features to NamedValueCache; reason=${String(err)}`,
                null,
                __fileline
            );
        }
    }
    features.setInstance(initFeatureEnrollment);

    if (features.instance.isEnrolledIn('StreamReachVideo')) {
        platform.addPermission(Permission.PLAY_REACH_VIDEO);
    }
}

export async function initializeLabOptions(platform: NamedValueCacheInterface): Promise<void> {
    const initLabOptions = new LabOptions(platform);
    try {
        await initLabOptions.initialize();
        Log.Info('Successfully retrieved LabOptions.', null, __fileline);
    } catch (err) {
        Log.Error('Failed to retrieve LabOptions.', null, __fileline, {
            results: err,
        });
    }
    labOptions.setInstance(initLabOptions);
}
